/**
 * @file AppConstants.js
 * @description Centralized constants for punch rules and issue types across the application.
 * @author
 * @version 1.0.0
 */

/**
 * @constant
 * @description Contains all rule identifiers used throughout the app.
 */
const AppConstant = Object.freeze({
  SHIFT_LOCKOUT_RULE: "ShiftLockout",
  MEAL_LOCKOUT_RULE: "Meal Lockout",
  DUPLICATE_PUNCH_RULE: "Duplicate Punch",

  ANY_EVENT_CODE: "0",
  SAME_EVENT_CODE: "1",
  SAME_EVENT_TYPE: "2",

  ANY_EVENT_CODE_LIST: Object.freeze(["0", "1", "2", "3", "4", "5", "10"]),
  SAME_EVENT_TYPE_IN: Object.freeze(["0", "3", "5", "10"]),
  SAME_EVENT_TYPE_OUT: Object.freeze(["1", "2", "4"]),
  SELF_SERVICE_EVENT_CODES: Object.freeze(["8", "9", "11", "12", "14", "15", "18"]),

  /**
   * Issue type codes for punch validation and processing.
   * These values are system-defined and used across frontend & backend.
   */
  ISSUE_TYPE: Object.freeze({
    
  NO_ISSUE: 0, // No Issue / OK Punch
  OFFLINE_FAST_PUNCH: 2, // Offline Fast Punch (Remote Calculation)
  MEAL_LOCKOUT: 4, // Meal Lockout
  EARLY_PUNCH_MEAL_LOCKOUT: 6, // Early Punch Meal Lockout
  OFF_SHIFT_PUNCH: 8, // Off Shift Punch
  INVALID_PUNCH_TIME: 20, // Invalid Punch Time (Duplicate Punch)
  VISITOR_PUNCH: 24, // Visitor’s Punch
  ATTESTATION_REJECTED: 26, // Attestation Rejected Punch
  INVALID_ATTESTATION_CONFIG: 28, // Invalid Attestation Configuration
  TEMP_HIGH: 30, // Employee’s Body Temperature - High
  TEMP_LOW: 32, // Employee’s Body Temperature - Low
  FACE_MASK_ABSENT: 34, // Face Mask Absent
  SHIFT_DATA_UNAVAILABLE: 36, // Shift-Schedule Data Unavailable
  ONLINE_ATTESTATION_FAIL: 38, // Online Attestation API Call Fail
  EMP_CERT_MISSING: 40, // Employee Certificate Missing
  EMP_CERT_EXPIRED: 42, // Employee Certificate Expired
  INVALID_EMPLOYEE: 46, // Invalid Employee
  }),

});

export default AppConstant;
